import axios from "axios";
import { del, get, post, patch,  put } from "./actions_api_helper";
import * as url from "./actions_url_helper";





// Get features
export const getActions = () => get(url.GET_ACTIONS);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
export const addNewAction = action => post(url.ADD_NEW_ACTION, {action: action});


// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateAction = action => patch(`${url.UPDATE_ACTION}/${action.uid}`,   { action: action  });


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteAction = action => del(`${url.DELETE_ACTION}/${action}`);







export {
  //getLoggedInUser,
  
  
};
